import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import Transition from 'react-transition-group/Transition';
import { propFunc, propStr } from '@/helpers/custom-prop-types';
import { CLASS_NAME_HEADER } from '@/utils/constants/element/layout';
class NotificationMessage extends Component {
    constructor(props) {
        super(props);
        this.revertState = () => {
            this.setState({ isRun: false });
        };
        this.getShowClass = (state) => {
            if (['entering', 'entered'].includes(state)) {
                return '';
            }
            return 'is-disabled';
        };
        this.getShowStyle = (state) => {
            if (['entering', 'entered'].includes(state)) {
                const header = document.querySelector(`header.${CLASS_NAME_HEADER}`);
                if (header) {
                    const height = header.clientHeight;
                    return { top: `${height}px` };
                }
            }
            return {};
        };
        this.state = { isRun: false };
    }
    componentDidMount() {
        // component表示と同時にanimationを実施
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({ isRun: true });
            });
        });
    }
    render() {
        const { isRun } = this.state;
        const { className, hideNotification, message } = this.props;
        return (_jsx(Transition, Object.assign({ in: isRun, onEntered: this.revertState, onExited: hideNotification, timeout: 3000 }, { children: (state) => (_jsx("div", Object.assign({ className: `l-header-status ${className} ${this.getShowClass(state)}`, style: this.getShowStyle(state) }, { children: message }))) })));
    }
}
NotificationMessage.propTypes = {
    className: propStr().isRequired,
    hideNotification: propFunc().isRequired,
    message: propStr().isRequired,
};
export default NotificationMessage;
